import { Text } from "@totalenergiescode/mobility-business-rev-design-system";
import { useTranslation } from "react-i18next";

import { NOTIFICATIONS_PER_PAGE } from "@/api/graphql/notifications/constants.ts";
import {
  StyledCard,
  StyledCountNotificationsText,
  StyledCurrentCountOnTotalContainer,
  StyledCurrentCountOnTotalText,
  StyledCustomTable,
  StyledCustomTableContainer,
  StyledPageHeader,
} from "@/components/Notifications/account/styles.ts";
import { NotificationsListPerAccountProps } from "@/components/Notifications/account/types.ts";
import { EmptyDataForThisFilter } from "@/components/shared/EmptyComponent";
import { Loading } from "@/components/shared/Loading";

export const NotificationsListPerAccount = ({
  id,
  useNotificationTableData,
  useBreadCrumbItems,
}: NotificationsListPerAccountProps) => {
  const { t: tCommon } = useTranslation("common");
  const { t: tNotifications } = useTranslation("notifications");
  const {
    columns,
    rows,
    totalNotifications,
    isNotificationsLoading,
    isAccountLoading,
    companyData,
    hasNextPage,
    fetchNextPage,
  } = useNotificationTableData(id);
  const breadcrumbItems = useBreadCrumbItems(companyData?.name);

  return (
    <>
      <StyledPageHeader
        breadcrumbItems={breadcrumbItems}
        title={tNotifications("notifications.title")}
        href={""}
      />

      <StyledCard>
        <Text variant={"text2"}>
          {tNotifications("notifications.account.subTitle")}
        </Text>
      </StyledCard>

      <Loading isLoading={isNotificationsLoading || isAccountLoading}>
        <>
          <StyledCountNotificationsText variant={"text2"}>
            {`${totalNotifications} ${tNotifications(
              "notifications.account.notifications",
              {
                count: Number(totalNotifications),
              },
            )}`}
          </StyledCountNotificationsText>
          <StyledCustomTableContainer>
            <StyledCustomTable
              rows={rows}
              columns={columns}
              loadMoreButton={{
                dataTestId: "notifications__list_load-more-button",
                label: tCommon("common.pagination.nextPage", {
                  pageSize: NOTIFICATIONS_PER_PAGE,
                }),
                onClick: fetchNextPage,
                isDisabled: !hasNextPage,
              }}
            />
            {totalNotifications === 0 && (
              <EmptyDataForThisFilter
                principalText={tNotifications("notifications.table.noData")}
              />
            )}
            <StyledCurrentCountOnTotalContainer>
              <StyledCurrentCountOnTotalText variant='sub3'>
                {tNotifications(
                  "notifications.namesWithCurrentCountOnTotal.name",
                  {
                    count: rows.length,
                    total: totalNotifications,
                  },
                )}
              </StyledCurrentCountOnTotalText>
            </StyledCurrentCountOnTotalContainer>
          </StyledCustomTableContainer>
        </>
      </Loading>
    </>
  );
};
